export enum IRNGType {
    WICHMANN_HILL = 0,
    MARSAGLIA_MULTICARRY,
    SUPER_DUPER,
    MERSENNE_TWISTER,
    KNUTH_TAOCP,
    KNUTH_TAOCP2002,
    LECUYER_CMRG
}




// WEBPACK FOOTER //
// ./src/lib/rng/irng-type.ts